import { cx } from "./util";

/** Text progress bar. The gap between value and target renders as skill debt (alert ▒). */
export default function AsciiMeter({ label, value = 0, target, width = 24, className }) {
  const val = Math.max(0, Math.min(100, value));
  const tgt = target == null ? null : Math.max(val, Math.min(100, target));
  const have = Math.round((val / 100) * width);
  const need = tgt == null ? have : Math.round((tgt / 100) * width);
  const debt = Math.max(0, need - have);
  return (
    <div className={cx("gd-meter", className)} role="meter" aria-valuenow={val} aria-valuemin={0} aria-valuemax={100} aria-label={label}>
      <span className="gd-meter-label">{label}</span>
      <span className="gd-meter-bar" aria-hidden="true">
        [<span className="gd-meter-have">{"█".repeat(have)}</span>
        <span className="gd-meter-debt">{"▒".repeat(debt)}</span>
        <span className="gd-meter-rest">{"░".repeat(width - have - debt)}</span>]
      </span>
      <span className="gd-meter-val">
        <b>{val}%</b>
        {tgt != null && tgt > val && <span className="gd-meter-debt"> -{tgt - val}</span>}
      </span>
    </div>
  );
}
